import React, { useEffect, useRef, useState } from 'react';
import { Player } from 'bitmovin-player';
import { UIFactory } from 'bitmovin-player/bitmovinplayer-ui';

import { fetchPlayApiSource } from '@repo/utils';

import 'bitmovin-player/bitmovinplayer-ui.css';

function BitmovinPlayer() {

  const [player, setPlayer] = useState(null);

  const playerConfig = {
    key: '378a99c6-1097-4afa-a8a8-a70762280eb1',
    ui: false,
     network: {
          preprocessHttpRequest: (type, request) => {
            if (type === ('drm/certificate/fairplay')) {
              request.responseType = 'arraybuffer'
            }
            if (type === ('drm/license/fairplay')) {
              request.credentials = 'include'
            }
            return Promise.resolve(request)
          },
        },
  };

  const playerDiv = useRef();

  useEffect(() => {
    function setupPlayer({ playerSource } = {}) {
      const playerInstance = new Player(playerDiv.current, playerConfig);
      UIFactory.buildDefaultUI(playerInstance);
      playerInstance.load(playerSource).then(() => {
        setPlayer(playerInstance)
        console.log('Successfully loaded source');
      }, () => {
        console.log('Error while loading source');
      });
    }

    fetchPlayApiSource('https://api.dev.streaming.channel4.com/1.6/A/ENG/DOTCOM/ALL/PLAY/LIVE/11347', true)
      .then(function ({ srcCfg }) {
        setupPlayer({ playerSource : srcCfg });
      })
      .catch(function (err) {
        console.warn(err)
      });

    return () => {
      function destroyPlayer() {
        if (player != null) {
          player.destroy();
          setPlayer(null);
        }
      }

      destroyPlayer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div id='player' ref={playerDiv} />;
}

export default BitmovinPlayer;
